<div class="buttons-wrapper">
  <a class="store-button" href="https://apps.apple.com/at/app/fan-at/id1484611537" target="_blank">
    <img src="https://static.fan.at/website/app-store.svg" style="width: 135px; object-fit: contain;">
  </a>
  <a class="store-button" href="https://play.google.com/store/apps/details?id=at.fan" target="_blank">
    <img style="width: 135px; object-fit: contain;" src="https://static.fan.at/website/google-play.svg">
  </a>
  <a class="store-button" href="https://appgallery.huawei.com/app/C104345843" target="_blank">
    <img style="width: 135px; object-fit: contain;" src="https://static.fan.at/website/huawei-gallery.svg">
  </a>
</div>
